import styled, { css, keyframes } from "styled-components";

export const TableContainer = styled.table`
  width: max-content;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;

  td + td,
  th + th {
    border-left: 1px solid #e5e7eb;
  }

  tbody td {
    border-bottom: 1px solid #f0f0f0;
  }

  tbody tr {
    --row-bg: #ffffff;
  }

  tbody tr:nth-child(odd) {
    --row-bg: #fbfdff;
  }

  tbody tr:hover {
    --row-bg: #f5f7fb;
  }

  tbody tr[data-selected="true"] {
    --row-bg: #eef2ff;
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  font-size: 13px;
  text-align: center;
  background: var(--row-bg);
  border-bottom: 1px solid #f0f0f0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ThCheck = styled.th`
  width: 42px;
  padding: 10px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
`;

export const TdCheck = styled.td`
  width: 42px;
  text-align: center;
  background: var(--row-bg);
  border-bottom: 1px solid #f0f0f0;
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
`;

export const NetDot = styled.span<{ $on: boolean }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  ${({ $on }) =>
    $on
      ? css`
          background: #16a34a;
          animation: ${pulse} 1.5s infinite;
        `
      : css`
          background: #9ca3af;
        `}
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonBox = styled.div`
  width: 100%;
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 37%, #f3f4f6 63%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.3s infinite linear;
`;
